import { render, staticRenderFns } from "./reportAccount.vue?vue&type=template&id=10920566&scoped=true"
import script from "./reportAccount.vue?vue&type=script&lang=js"
export * from "./reportAccount.vue?vue&type=script&lang=js"
import style0 from "./reportAccount.vue?vue&type=style&index=0&id=10920566&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10920566",
  null
  
)

export default component.exports